import { render, staticRenderFns } from "./indetail.vue?vue&type=template&id=42ceb594&scoped=true&"
import script from "./indetail.vue?vue&type=script&lang=js&"
export * from "./indetail.vue?vue&type=script&lang=js&"
import style0 from "./indetail.vue?vue&type=style&index=0&id=42ceb594&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ceb594",
  null
  
)

export default component.exports